import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import GridContainer from '../../../../@jumbo/components/GridContainer';
import Grid from '@material-ui/core/Grid';
import AppTextInput from '../../../../@jumbo/components/Common/formElements/AppTextInput';
import Button from '@material-ui/core/Button';
import AppSelectBox from '../../../../@jumbo/components/Common/formElements/AppSelectBox';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { CircularProgress, ListItemText, MenuItem, TextField } from '@material-ui/core';
import { addPayeoff, updatePayeoff } from 'redux/actions/Finance';
import { Autocomplete } from '@material-ui/lab';
import { getUsersList, setFilterUsers } from 'redux/actions/userInfo';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import useDebounce from '@jumbo/utils/hooks/useDebounce/useDebounce';

const stateMap = [
  { id: 'approved', label: 'موفق' },
  { id: 'pending', label: 'در حال بررسی' },
  { id: 'canceled', label: 'ناموفق' },
];

const CreatePayoffFrom = ({ payoff }) => {
  const { id, amount, created_at, user, state } = payoff || {};

  const history = useHistory();
  const dispatch = useDispatch();

  const [cost, setCost] = useState(amount || 0);
  const [payoffState, setPayoffState] = useState(state || '');
  const [date, setDate] = useState({ format: 'MM/DD/YYYY', date: new Date(created_at) || '' });
  const [userInfo, setUserInfo] = useState(user || '');
  const [search, setSearch] = useState('');
  const [open, setOpen] = React.useState(false);

  const { usersList, userFilter } = useSelector(({ userInfo }) => userInfo);

  const loading = open && usersList?.length === 0;

  const searchDebounced = useDebounce(search, 500);

  useEffect(() => {
    dispatch(setFilterUsers({ by_name: searchDebounced }));
  }, [dispatch, searchDebounced]);

  const handleSubmit = () => {
    const data = {
      state: payoffState,
      amount: cost,
      created_at: date.jsDate,
      user_id: userInfo?.id,
    };
    if (payoff === null) {
      dispatch(addPayeoff(data, history));
    } else {
      dispatch(updatePayeoff(data, id));
    }
  };

  useEffect(() => {
    dispatch(getUsersList(userFilter));
  }, [dispatch, userFilter]);

  const convert = (date, format = date.format) => {
    let object = { date, format };

    setDate({
      persian: new DateObject(object).format(),
      jsDate: date.toDate().toISOString(),
      ...object,
    });
  };

  return (
    <React.Fragment>
      <GridContainer>
        <Grid item xs={12} sm={6}>
          <AppSelectBox
            fullWidth
            data={stateMap}
            label="وضعیت"
            value={payoffState}
            onChange={e => setPayoffState(e.target.value)}
            valueKey="id"
            variant="outlined"
            labelKey="label"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AppTextInput
            fullWidth
            variant="outlined"
            label="مبلغ"
            value={cost}
            onChange={e => {
              setCost(e.target.value);
            }}
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            fullWidth
            id="combo-box-user-id"
            options={usersList}
            open={open}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            loading={loading}
            disableCloseOnSelect
            value={userInfo ? userInfo : ''}
            getOptionSelected={(option, value) => option.fullname === value.fullname}
            onChange={(event, value) => setUserInfo(value)}
            onInputChange={(event, newInputValue) => setSearch(newInputValue)}
            getOptionLabel={option => option.fullname || ''}
            renderInput={params => (
              <TextField
                {...params}
                label="نام کاربر"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
            renderOption={(props, option) => {
              return (
                <MenuItem {...props}>
                  <ListItemText primary={props.fullname} style={{ marginRight: 7 }} />
                </MenuItem>
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DatePicker
            render={<TextField fullWidth variant="outlined" label="تاریخ" placeholder="روز/ماه/سال" />}
            value={date.date}
            onChange={convert}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="top-right"
          />
        </Grid>
      </GridContainer>
      <Box display="flex" justifyContent="flex-end" mb={4}>
        <Button onClick={() => history.goBack()}>{payoff === null ? 'لغو' : 'بازگشت'}</Button>
        <Box ml={2}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            {payoff ? 'اعمال تغییرات' : 'ثبت اطلاعات'}
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default CreatePayoffFrom;

CreatePayoffFrom.prototype = {
  selectedContact: PropTypes.object,
};

CreatePayoffFrom.defaultProps = {
  selectedContact: null,
};
